import { render, staticRenderFns } from "./organizationalChart.vue?vue&type=template&id=2a86b766&scoped=true&"
import script from "./organizationalChart.vue?vue&type=script&lang=js&"
export * from "./organizationalChart.vue?vue&type=script&lang=js&"
import style0 from "./organizationalChart.vue?vue&type=style&index=0&id=2a86b766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86b766",
  null
  
)

export default component.exports